/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brand_Home_TitleInputs */

const en_brand_home_title = /** @type {(inputs: Brand_Home_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What will you build today?`)
};

const id_brand_home_title = /** @type {(inputs: Brand_Home_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mau membangun apa hari ini?`)
};

/**
* | output |
* | --- |
* | "What will you build today?" |
*
* @param {Brand_Home_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const brand_home_title = /** @type {((inputs?: Brand_Home_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brand_Home_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_brand_home_title(inputs)
	return en_brand_home_title(inputs)
});